// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__IB1un","newSearchResultBox":"search_newSearchResultBox__1fsLm","ef-box":"search_ef-box__xbp_1"};